import inventoryAdjustmentApi from '../../../api/inventory/inventoryAdjustmentApi';
import {
  InventoryAdjustmentCreateDTO,
  InventoryAdjustmentUpdateDTO,
} from '../../../types/inventory/adjustment/InventoryAdjustmentTypes';

const InventoryAdjustmentService = {
  /**
   * ➕ Crear ajuste de inventario (solo encabezado)
   * POST /api/inventory/adjustments
   */
  create: async (payload: InventoryAdjustmentCreateDTO) => {
    const response = await inventoryAdjustmentApi.add(payload);
    return response.data;
  },

  /**
   * ✏️ Actualizar encabezado del ajuste
   * PUT /api/inventory/adjustments/{id}
   */
  update: async (id: number, payload: InventoryAdjustmentUpdateDTO) => {
    const response = await inventoryAdjustmentApi.modify(id, payload);
    return response.data;
  },

  /**
 * 🔒 Finalizar ajuste
 * PUT /api/inventory/adjustments/{id}/finalize
 */
  finalize: async (id: number) => {
    const response = await inventoryAdjustmentApi.modifyCustom(
      `/${id}/finalize`,
      {}
    );
    return response.data;
  },


  /**
   * 🔍 Obtener ajuste completo por ID
   * GET /api/inventory/adjustments/{id}
   */
  getById: async (id: number) => {
    const response = await inventoryAdjustmentApi.fetchById(id);
    return response.data;
  },

  /**
   * ✅ Aprobar ajuste
   * PUT /api/inventory/adjustments/{id}/approve
   */
  approve: async (id: number) => {
    const response = await inventoryAdjustmentApi.modifyCustom(
      `/${id}/approve`,
      {}
    );
    return response.data;
  },

  /**
   * ❌ Rechazar ajuste
   * PUT /api/inventory/adjustments/{id}/reject
   */
  reject: async (id: number) => {
    const response = await inventoryAdjustmentApi.modifyCustom(
      `/${id}/reject`,
      {}
    );
    return response.data;
  },

  /**
   * 🟥 Cancelar ajuste
   * PUT /api/inventory/adjustments/{id}/cancel
   */
  cancel: async (id: number) => {
    const response = await inventoryAdjustmentApi.modifyCustom(
      `/${id}/cancel`,
      {}
    );
    return response.data;
  },

  /**
   * 🔄 Revertir ajuste
   * PUT /api/inventory/adjustments/{id}/revert
   */
  revert: async (id: number) => {
    const response = await inventoryAdjustmentApi.modifyCustom(
      `/${id}/revert`,
      {}
    );
    return response.data;
  },

  /**
   * ⚡ Crear ajuste en borrador que reinicia a 0 los productos en negativo
   * de un grupo guardado, en una sucursal.
   * POST /api/inventory/adjustments/reset-group
   */
  resetGroupToZero: async (payload: { groupId: number; branchId: number; reason?: string }) => {
    const response = await inventoryAdjustmentApi.addCustom('/reset-group', payload);
    return response.data;
  },
};

export default InventoryAdjustmentService;
